const ACCENTS = {
  teal: "bg-cass-teal/15 text-cass-teal", sky: "bg-sky-100 text-sky-600", violet: "bg-violet-100 text-violet-600",
  fuchsia: "bg-fuchsia-100 text-fuchsia-600", indigo: "bg-indigo-100 text-indigo-600", amber: "bg-amber-100 text-amber-600",
  navy: "bg-cass-navy/10 text-cass-navy", emerald: "bg-emerald-100 text-emerald-600", orange: "bg-orange-100 text-orange-500",
  rose: "bg-rose-100 text-rose-600",
};

export default function SettingsTile({ title, desc, accent = "navy", Icon, onClick }) {
  return (
    <button onClick={onClick} data-testid={`settings-tile-${title.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
      className="text-left bg-white border border-border rounded-2xl p-5 flex items-start gap-4 hover:border-cass-teal hover:shadow-md transition-all">
      <span className={`w-12 h-12 rounded-xl grid place-items-center shrink-0 ${ACCENTS[accent] || ACCENTS.navy}`}>{Icon && <Icon className="w-6 h-6" />}</span>
      <div className="min-w-0">
        <div className="font-alt font-semibold text-cass-navy">{title}</div>
        <div className="text-xs text-cass-slate mt-1">{desc}</div>
      </div>
    </button>
  );
}
